
import 'angularjs-color-picker/dist/angularjs-color-picker.min.css';
import 'angularjs-color-picker/dist/themes/angularjs-color-picker-bootstrap.min.css';
import 'ng-toast/dist/ngToast.css';
import 'ng-toast/dist/ngToast-animations.css';
import 'ng-dialog/css/ngDialog.css';
import 'ng-dialog/css/ngDialog-theme-default.css';
import 'sweetalert/dist/sweetalert.css';
import 'angular-bootstrap-datetimepicker/src/css/datetimepicker.css';
import 'angular-ui-switch/angular-ui-switch.css';
import './bootstrap/css/bootstrap.css';
import './bootstrap/css/bootstrap-theme.css';
import './mangooid-font/style.css';
import './ubuntu-titling-fontfacekit/web fonts/ubuntutitling_bold_macroman/stylesheet.css';
import './main.css';
import 'angular-google-places-autocomplete/src/autocomplete.css';
import 'angularjs-slider/dist/rzslider.min.css';

import angular from 'angular';
import 'angular-i18n/angular-locale_fr-fr';
import uirouter from 'angular-ui-router';
import ngAnimate from 'angular-animate';
import moment from 'moment';
import translate from 'angular-translate';

import 'angularjs-slider';
import 'sweetalert';
import 'bootstrap';
import 'angular-ui-switch';
import 'angular-bootstrap-datetimepicker/src/js/datetimepicker.js';
import 'angular-bootstrap-datetimepicker/src/js/datetimepicker.templates.js';
import 'chart.js';
import 'angular-chart.js';
import 'tinycolor2';
import 'angularjs-color-picker';
import 'angular-utils-pagination/dirPagination.js';
import 'angular-google-places-autocomplete';
import 'angular-google-places-autocomplete/src/autocomplete.js';

import routing from './app.config';

import loader from './directive/loader';

import login from './page/login';
import ssoLogin from './page/ssoLogin';
import stores from './page/stores';
import storeForm from './page/storeForm';
import summary from './page/summary';
import summaryRanking from './page/summaryRanking';
import receiptsDetails from './page/receiptsDetails';
import tutorial from './page/tutorial';
import reviews from './page/reviews';
import reviewsIndicators from './page/reviewsIndicators';
import reviewsRanking from './page/reviewsRanking';
import productsRating from './page/productsRating';
import marketers from './page/marketers';
import marketerForm from './page/marketerForm';
import preferences from './page/preferences';
import surveys from './page/surveys';
import surveyForm from './page/surveyForm';
import surveyStats from './page/surveyStats';
import emailTemplates from './page/emailTemplates';
import emailTemplateForm from './page/emailTemplateForm';


const language = 'fr';

moment.locale(language);

angular.module('app', [
	uirouter,
	ngAnimate,
	translate,

	// directives
	loader,
	'color.picker',
	'angularUtils.directives.dirPagination',
	'rzModule',

	// pages
	login,
	ssoLogin,
	stores,
	storeForm,
	summary,
	summaryRanking,
	receiptsDetails,
	tutorial,
	reviews,
	reviewsIndicators,
	reviewsRanking,
	productsRating,
	marketers,
	marketerForm,
	preferences,
	surveys,
	surveyForm,
	surveyStats,
	emailTemplates,
	emailTemplateForm,
])
.config(routing)
.config(['ngToastProvider', function (ngToastProvider) {
	ngToastProvider.configure({
		animation: 'fade' 
	});
}])
.config(['ChartJsProvider', function (ChartJsProvider) {
	ChartJsProvider.setOptions('global', {
		scaleFontFamily: "'Arial', sans-serif",
		tooltipFontFamily: "'Arial', sans-serif",
		tooltipTitleFontFamily: "'Arial', sans-serif",
		legend: {
			display: true,
			position: 'bottom',
		},
		layout: {
			padding: {
				left: 5,
				right: 5,
				top: 5,
				bottom: 5,
			},
		},
		scales: {
			yAxes: [{
				ticks: {
					beginAtZero: true,
					suggestedMin: 0,
				},
			}],
		},
		colors: [
			'#F47100',
			'#93AE29',
			'#0099F4',
			'#D600F4',
			'#F40033'
		]
	});
}])
.config(['$translateProvider', function ($translateProvider) {
	$translateProvider.translations('en', require('./translation/en'));
	$translateProvider.translations('fr', require('./translation/fr'));
	$translateProvider.preferredLanguage(language);
}])
.run(['$rootScope', function($rootScope) {
	$rootScope.favicon = require('./favicon.ico');
	$rootScope.favicon16 = require('./favicon-16.png');
	$rootScope.favicon32 = require('./favicon-32.png');
	$rootScope.favicon48 = require('./favicon-48.png');
	$rootScope.favicon64 = require('./favicon-64.png');
}])
.run(['$rootScope', 'Loader', '$state', function($rootScope, Loader, $state) {
	var errorAction = (page, params) => {
		$state.go(page, params);
		Loader.close();
	};

	$rootScope.$on('$stateChangeStart',   _ => Loader.open());
	$rootScope.$on('$stateChangeSuccess', _ => Loader.close());

	$rootScope.$on('$stateNotFound',      _ => errorAction('summaryPage'));
	$rootScope.$on('$stateChangeError',   (event, toState, toParams, fromState, fromParams, error) => errorAction('loginPage', {
		redirect: JSON.stringify({
			state: toState.name,
			params: toParams,
		})
	}));
}]);



// WEBPACK FOOTER //
// ./src/app.js